import { Component, Prop, Vue } from "vue-property-decorator";

import Card from "@/components/Card.tsx";
import { CreateElement } from "vue";

@Component
export default class ReadingTask2Passage extends Vue {
  private _passage: [];
  private balaTasks: any;
  /*
  passage = [
    "What do you think bats eat? With close to 1000 different types of bats, it’s not surprising that bats eat many different types of food. Let’s take a closer look.",
    "Bats that eat insects are called insectivores. Most bats are insectivores, and they especially like to eat small flying bugs like mosquitoes and moths. They also eat beetles and caterpillars. Did you know that a little brown bat can eat 1,200 mosquitoes in one hour? Because of their voracious appetites, bats are a major factor in controlling insect populations. In other words, bats help people by reducing the need for pesticides and bug spray.",
    " Other bat species feed on plants, and they can be divided into nectarivores and frugivores. \n" +
      "Nectarivores eat the nectar and pollen from flowering plants. Some of them have even been known to drink sugar water from hummingbird feeders. Frugivores eat fruits and seeds, and their favorite foods are figs, mangoes, dates, and bananas.",
    "Both nectarivores and frugivores are crucial to rainforests. Frugivores eat fruit, but the fruit seeds \n" +
      "pass whole through a bat’s digestive system. The plant seeds are spread as bats fly from place to place. \n" +
      "This allows plants to sprout and grow in new areas.",
    "About a dozen species of bats are carnivores, which means they eat meat. Carnivorous bats hunt and kill their prey, which include small animals such as mice, birds, lizards, frogs, fish – even other bats. They are great hunters because they can locate the faintest sounds and smallest movements. Some bats are particularly skilled at catching frogs, some catch birds in flight, and others are very good at grabbing fish on the water’s surface",
    "One of the most famous and frightening types of bats are “vampire” bats. There are only three types of vampire bats, and their habitat is Central and South America. Called sanguivores, these bats really do drink blood! But don't worry –  vampire bats do not prefer human blood. However, they might feed on humans who are sleeping outside or in rooms without window screens. Sanguivore bats mainly get blood from larger mammals such as cows, sheep, and horses. To get blood, vampire bats make a small cut in a sleeping animal’s skin and lap up a little bit of blood. They only need about two teaspoons of blood each day. It’s such a small amount that often the cow or sheep does not even wake up while the bat is feeding. These bats also have a special chemical in their saliva that keeps their prey’s blood flowing. While this is bad for their prey, it has been used in some human medications to help with blood and heart problems."
  ];
  */

  constructor() {
    super();
    this._passage = this.$store.getters.balaPassages.readingTask2;
    this.balaTasks = this.$store.getters.balaSections;
  }

  beforeCreate() {
    this._passage = this.$store.getters.balaPassages.readingTask2;
  }

  render(h: CreateElement) {
    return (
      <Card title={this.balaTasks[2].name}>
        <div slot="mainContent">
          <v-list class="overflow-y-auto" max-height="340px">
            {this._passage.map((line, i) => (
              <v-list-item>
                <v-row>
                  <v-col cols="1">{i + 1}</v-col>
                  <v-col cols="11">
                    {this.$createElement("p", {
                      domProps: {
                        innerHTML: line
                      }
                    })}
                  </v-col>
                </v-row>
              </v-list-item>
            ))}
          </v-list>
        </div>
        <div slot="actions">
          <v-spacer></v-spacer>
          <v-btn color="secondary" to="understanding">
            Next
          </v-btn>
        </div>
        <div slot="progressBar">
          <v-spacer></v-spacer>
          <v-progress-linear
            value={Math.round(this.$store.getters.progressBala)}
            height="4"
            opacity="0.3"
            striped={true}
          ></v-progress-linear>
        </div>
      </Card>
    );
  }
}

const component = ReadingTask2Passage;
